import React from 'react';
import Collapse, { Panel } from 'rc-collapse';
import { withTranslation, WithTranslation } from 'react-i18next';
import DateTimePicker from '../common/DateTime';

interface TimeRangePanelOwnProps {
  timeFrom: string;
  timeTo: string;
  // Infinity checkboxes stay uncontrolled; the handlers receive the toggled value
  // straight from the change event.
  onToggleFromInfinity: (checked: boolean) => void;
  onToggleToInfinity: (checked: boolean) => void;
  onChangeTimeFrom: (time: Date | number | null) => void;
  onChangeTimeTo: (time: Date | number | null) => void;
  // Fires on Collapse expand/collapse — sizes the datepicker inputs to 100%.
  onCollapseChange: () => void;
}

// The superuser time-range block: a collapsible panel with a from/to date pair,
// each swappable for an -infinity / infinity sentinel via its checkbox.
const TimeRangePanel = ({
  timeFrom, timeTo, onToggleFromInfinity, onToggleToInfinity,
  onChangeTimeFrom, onChangeTimeTo, onCollapseChange, t,
}: TimeRangePanelOwnProps & WithTranslation) => (
  <Collapse onChange={() => onCollapseChange()}>
    <Panel header={t('dashboard.editor.time.range')} forceRender={true}>
      <div className="pure-u-18-24" style={{
        display: "flex",
        justifyContent: "flex-start",
        padding: "1rem",
      }}>
        <div className="pure-u-1-24">
          <input
            id="tickbox_time_from_infinity"
            type={'checkbox'}
            title="Time from infinity"
            defaultChecked={timeFrom === '-infinity'}
            onChange={(e) => onToggleFromInfinity(e.target.checked)}
          />
        </div>
        <div className="pure-u-8-24" style={{ display: timeFrom === '-infinity' ? "none" : "block" }}>
          <label>{t('dashboard.editor.time.from')}: </label>
          <DateTimePicker
            selected={timeFrom}
            parentCallback={onChangeTimeFrom}
          />
        </div>
        <div className="pure-u-8-24 time-range-input" style={{ display: timeFrom !== '-infinity' ? "none" : "block" }}>
          <label>{t('dashboard.editor.time.from')} -&#8734;</label>
          <input
            type="text"
            placeholder="-infinity"
            style={{ width: "100%" }}
            disabled
          />
        </div>
        <div className="pure-u-1-24">
          <input
            id="tickbox_time_to_infinity"
            type={'checkbox'}
            title="Time to infinity"
            defaultChecked={timeTo === 'infinity'}
            onChange={(e) => onToggleToInfinity(e.target.checked)}
          />
        </div>
        <div className="pure-u-8-24" style={{ display: timeTo === 'infinity' ? "none" : "block" }}>
          <label>{t('dashboard.editor.time.to')}: </label>
          <DateTimePicker
            selected={timeTo}
            parentCallback={onChangeTimeTo}
          />
        </div>
        <div className="pure-u-8-24 time-range-input" style={{ display: timeTo !== 'infinity' ? "none" : "block" }}>
          <label>{t('dashboard.editor.time.to')} &#8734;</label>
          <input
            type="text"
            placeholder="infinity"
            style={{ width: "100%" }}
            disabled
          />
        </div>
      </div>
    </Panel>
  </Collapse>
);

export default withTranslation('common')(TimeRangePanel);
